import * as React                      from 'react';

import { useAlert                    } from 'react-alert';

import { useTheme                    } from 'styled-components';

import { ProfileVector               } from 'src/components/vector/profile';
import { ServicePretenzStatusVector  } from 'src/components/vector/services/service-pretenz-status';
import { ServiceEnginePortalVector   } from 'src/components/vector/services/service-engine-portal';
import { ServiceCertCheckVector      } from 'src/components/vector/services/service-cert-check';
import { ServiceInternetShopVector   } from 'src/components/vector/services/service-internet-shop';
import { ServiceRestAPIVector        } from 'src/components/vector/services/service-rest-api';
import { ServiceTechconsultingVector } from 'src/components/vector/services/service-techconsulting';
import { ServiceShadeSelectionVector } from 'src/components/vector/services/service-shade-selection';
import { ServiceProductCounterVector } from 'src/components/vector/services/service-product-counter';

import { NavBar                      } from 'src/components/features/common/nav-bar';
import { Toolbar                     } from 'src/components/features/main/common/toolbar';
import { IconList,
         IconListElement             } from 'src/components/features/main/common/icon-list';

import { Screen,
         ScreenBody,
         layout_light,
         layout_dark,                } from 'src/containers/main/services/layout';

import { Urls                        } from 'src/providers/routing';
import { themeColors                 } from 'src/providers/theme/shared';

import * as types                      from 'src/services/api/types';

import { useAppSelector, 
         storeApi                    } from 'src/store';



const { Client, ClientAdmin, Contractor, Stpk } = types.auth.AccountRole;

const allItems: IconListElement[] = [
  {
    code: 'pretenzstatus',
    busy: false,
    icon: <ServicePretenzStatusVector />,
    iconBackgroundColor: themeColors.AccentPrimaryBluePrimary01,
    label: 'Статусы по претензиям',
    availableFor: (account: types.auth.AccountWithTokens) => [ClientAdmin, Stpk].includes(account.role) || account.isClaimStatus,
  },
  {
    code: 'certcheck',
    busy: false,
    icon: <ServiceCertCheckVector />,
    iconBackgroundColor: themeColors.AccentSecondaryEmerald01,
    label: 'Проверка сертификата',
    availableFor: (account: types.auth.AccountWithTokens) => [Client, ClientAdmin, Contractor, Stpk].includes(account.role),
  },
  {
    code: 'engineportal',
    busy: false,
    icon: <ServiceEnginePortalVector />,
    iconBackgroundColor: themeColors.AccentSecondaryBurgundy01,
    label: 'Инжиниринговый портал',
    availableFor: (account: types.auth.AccountWithTokens) => [Client, ClientAdmin, Contractor, Stpk].includes(account.role),
  },
  {
    code: 'productcounter',
    busy: false,
    icon: <ServiceProductCounterVector />,
    iconBackgroundColor: themeColors.AccentPrimaryBluePrimary01,
    label: 'Счетчик продукции',
    availableFor: (account: types.auth.AccountWithTokens) => {
      const playCounterConfig = account.configs.find((item) => item.code === 'PLAYCOUNTER') ?? null;

      return (playCounterConfig !== null) && playCounterConfig.value === '1';
    }
  },
  {
    code: 'internetshop',
    busy: false,
    icon: <ServiceInternetShopVector />,
    iconBackgroundColor: themeColors.AccentSecondaryLavender01,
    label: 'Интернет-магазин',
    availableFor: (account: types.auth.AccountWithTokens) => [Client, ClientAdmin, Contractor, Stpk].includes(account.role),
  },
  {
    code: 'restapi',
    busy: false,
    icon: <ServiceRestAPIVector />,
    iconBackgroundColor: themeColors.AccentPrimaryBluePrimary01,
    label: 'Токен для REST API',
    availableFor: (account: types.auth.AccountWithTokens) => account.isRestApi,
  },
  {
    code: 'techconsulting',
    busy: false,
    icon: <ServiceTechconsultingVector />,
    iconBackgroundColor: themeColors.AccentSecondaryLavender01,
    label: 'Techconsulting',
    availableFor: (account: types.auth.AccountWithTokens) => [Client, ClientAdmin, Contractor, Stpk].includes(account.role),
  },
  {
    code: 'shadeselection',
    busy: false,
    icon: <ServiceShadeSelectionVector />,
    iconBackgroundColor: themeColors.AccentPrimaryBluePrimary01,
    label: 'Подбор оттенка',
    availableFor: (account: types.auth.AccountWithTokens) => {
      const shadeSelectionConfig = account.configs.find((item) => item.code === 'IND_SHADE_SELECTION') ?? null;

      return (shadeSelectionConfig !== null) && shadeSelectionConfig.value === '1';
    }
  },
  {
    code: 'lk',
    busy: false,
    icon: <ProfileVector />,
    iconBackgroundColor: themeColors.AccentSecondaryEmerald01,
    label: 'Личный кабинет клиента ПАО «Северсталь»',
    availableFor: (account: types.auth.AccountWithTokens) => [Client, ClientAdmin, Contractor, Stpk].includes(account.role),
  },
  /*
  {
    code: 'problem8d',
    busy: false,
    icon: <ServiceProblem8DVector />,
    label: 'Решение проблем 8D',
    availableFor: (account: types.auth.AccountWithTokens) => [ClientAdmin, Stpk].includes(account.role),
  },
  */
];

export const ServicesScreen = () => {
  const theme = useTheme();
  const alert = useAlert();
  const layout = theme.colorScheme === 'light' ? layout_light : layout_dark;
  const account = useAppSelector(storeApi.auth.common.selectors.selectAccount)!;

  let roleItems = allItems.filter((item) => item.availableFor(account))

  const onIconListItemTap = (item: IconListElement) => {
    switch (item.code)
    {
      case 'pretenzstatus':
        if (account.role === types.auth.AccountRole.Stpk)
        {
          Urls.QMMsgSelectCompany.build().navigate();
        }
        else
        {
          Urls.QMMsgListEsk.build('services', 'null').navigate();
        }
        break;
      case 'problem8d':
        alert.info('Раздел в разработке');
        break;
      case 'engineportal':
        window.open('https://vmeste.severstal.com/engineering-portal/', '_blank', 'noopener')?.focus();
        break;
      case 'certcheck':
        window.open('https://vmeste.severstal.com/sertcheck/chermk/', '_blank', 'noopener')?.focus();
        break;
      case 'internetshop':
        window.open('https://market.severstal.com/ru/ru/', '_blank', 'noopener')?.focus();
        break;
      case 'restapi':
        Urls.MainToken.build().navigate();
        break;
      case 'techconsulting':
        window.open('https://severstal.com/rus/clients/services/techconsulting/?utm_source=techconsulting&utm_medium=landing_page&utm_campaign=stories_checksteel', '_blank', 'noopener')?.focus();
        break;
      case 'lk':
        window.open('https://info.severstal.com/?utm_source=checksteel&utm_medium=services&utm_campaign=lk', '_blank', 'noopener')?.focus();
        break;
      case 'shadeselection':
        Urls.MainShadeSelection.build().navigate();
        break;
      case 'productcounter':
        Urls.MainProductCounter.build().navigate();
        break;
    }
  }

  return (
    <Screen layout={layout}>
      <NavBar
        variant = { layout.navbarVariant }
        label = 'Сервисы'
      />
      <ScreenBody layout = { layout }>
        <IconList
          variant = { layout.iconlistVariant }
          items = { roleItems }
          onItemTap = { onIconListItemTap }
        />
      </ScreenBody>
      <Toolbar variant = { layout.toolbarVariant } activeItem = 'services' />
    </Screen>
  );
};
